import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funktionsbereich-admin-hinzufuegen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungFunktionsbereichAdminHinzufuegenEffects {

    FunktionsbereichAdminHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN),
        mergeMap((x: ac.PostFunktionsbereichAdminHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunktionsbereichAdminHinzufuegen(x.funktionsbereichBenutzerRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunktionsbereichAdminHinzufuegenErfolgreichAction(result, x.funktionsbereichBenutzerRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunktionsbereichAdminHinzufuegenFehlerAction(error, x.funktionsbereichBenutzerRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunktionsbereicheCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunktionsbereicheCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunktionsbereicheCommandService);
        }
        return this.service;
    }
}
